import Image from 'components/Shared/Image';
import { Brand } from 'models/Brand';
import { PureComponent } from 'react';
import { NotifyLink } from 'components/Shared/NotifyLink';
import styles from './styles.scss';
import cn from 'classnames';

const BRAND_IMAGE_DIMENSIONS = {
  width: 1000,
  height: 35
};

export class BrandLink extends PureComponent<Brand, { imageVisible: boolean }> {
  public state = {
    imageVisible: false
  };

  public render() {
    const { url, ticket, title, brandImage } = this.props;
    return (
      <div className={styles.brandLinkContainer}>
        <div className={cn(styles.imageContainer, { [styles.visible]: this.state.imageVisible })}>
          {this.state.imageVisible && (
            <Image
              className={styles.image}
              {...brandImage}
              {...BRAND_IMAGE_DIMENSIONS}
              alt={title}
            />
          )}
        </div>
        <NotifyLink
          onMouseEnter={this.showImage}
          onMouseLeave={this.hideImage}
          className={styles.brandLink}
          url={url}
          ticket={ticket}
          key={title}
        >
          {title}
        </NotifyLink>
      </div>
    );
  }

  private showImage = () => this.setState({ imageVisible: true });
  private hideImage = () => this.setState({ imageVisible: false });
}
